import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43895c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'editableTitle',
  props: ["text"],
  emits: ["titleEdited"],
  setup(__props, { emit: __emit }) {


const props = __props
const emit = __emit

const isEditing = ref<boolean>(false)

const newTitle = ref<string>("")

const startEdit = () => {
    isEditing.value = true
    newTitle.value = props.text
}

const completeEdit = () => {
    isEditing.value = false
        if(newTitle.value.length > 3){
            emit("titleEdited", newTitle.value)
        }
}

const cancelEdit = () => {
    isEditing.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          class: "task-title",
          onDblclick: startEdit
        }, _toDisplayString(props.text), 33))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          autofocus: "",
          onBlur: completeEdit,
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => ($event.target?.blur()), ["enter"])),
          onKeydown: _withKeys(cancelEdit, ["esc"]),
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTitle).value = $event))
        }, null, 544)), [
          [_vModelText, newTitle.value]
        ])
  ]))
}
}

})